import styled from '@emotion/styled';
import { Stack } from './Stack';

export const StackRowPill = styled(Stack)`
  margin-bottom: 6px;
  background-color: #4f41b9;
  border-radius: 0.25rem;
  border: 0.1rem solid #2e266a;
  padding-bottom: 4px;
  padding-right: 0;
  align-items: flex-start;
  box-shadow: 0 10px 15px rgba(16, 27, 30, 0.4);
`;
